export type NumericValueConstraints = {
  min?: number
  max?: number
  step?: number
  defaultValue?: number
}

export function safeMin(...values: number[]) {
  return values.reduce((min, value) => (Number.isNaN(min) || (!Number.isNaN(value) && value < min) ? value : min), NaN)
}

export function safeMax(...values: number[]) {
  return values.reduce((max, value) => (Number.isNaN(max) || (!Number.isNaN(value) && value > max) ? value : max), NaN)
}

export function normalizeNumericValue(
  value: number,
  { min, max, step, defaultValue }: NumericValueConstraints
): number {
  if (Number.isNaN(value) && defaultValue !== undefined && !Number.isNaN(defaultValue)) {
    return defaultValue
  } else if (min !== undefined && Number.isFinite(min) && value < min) {
    return min
  } else if (max !== undefined && Number.isFinite(max) && value > max) {
    return max
  } else if (step !== undefined && Number.isFinite(step)) {
    const base = min ?? 0
    const valueRelativeToBase = value - base
    if (valueRelativeToBase < Number.EPSILON) {
      return base
    }
    // Number.EPSILON is just too small
    // it fails with things like 29 % 0.1 === 0.0999999999999984 > Number.EPSILON and thus we're rounding for no reason
    const epsilon = step / 1000
    if (step) {
      const mod = Math.abs(valueRelativeToBase % step)
      if ((mod < step / 2 && mod > epsilon) || (mod > step / 2 && mod < step - epsilon)) {
        return base + Math.round(valueRelativeToBase / step) * step
      }
    }
  }
  return value
}
